module.exports = __webpack_public_path__ + "static/img/icon4-7.65c78645.png";